// extracted by mini-css-extract-plugin
export default {"label":"FieldFolderSelect_label__O+fbl"};